import { render } from "./ToastStack.vue?vue&type=template&id=af58f384&scoped=true"
import script from "./ToastStack.vue?vue&type=script&lang=js"
export * from "./ToastStack.vue?vue&type=script&lang=js"

import "./ToastStack.vue?vue&type=style&index=0&id=af58f384&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-af58f384"

export default script